//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { userSettingsManager } from '../pages/main/sections/UserSettings/UserSettingsManager.js'

export default {
  name: 'ChangeViewBtn',
  mixins: [userSettingsManager],
  props: {
    view: {
      type: String,
      required: true
    },
    name: {
      type: String,
      required: true
    },
    url: {
      type: String,
      required: true
    },
    icon: {
      type: String,
      required: true
    },
    btnClass: {
      type: String,
      required: true
    },
    tooltip: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDefaultView: function () {
      return this.user.defaultView === this.view
    },
    hasAccessToView: function () {
      return this.user.availableViews.includes(this.view)
    }
  },
  methods: {
    onClick: async function (event) {
      event.preventDefault()

      await this.updateDefaultView()
      if (!this.isDefaultView) {
        this.$refs.contextMenu.show(event)
      } else {
        this.onOpenInNewTab()
      }
    },
    onContextMenu: function (event) {
      // if (this.isDefaultView) {
      //   event.preventDefault()
      // }
      this.updateDefaultView()
    },
    updateDefaultView: function () {
      return this.loadUserSettings()
        .then(settings => {
          const defaultViewSetting = settings['ui.common.view']
          const defaultView = (defaultViewSetting && defaultViewSetting.value) || null
          if (this.user.defaultView !== defaultView) {
            this.user.defaultView = defaultView
          }
          return defaultView
        })
    },
    onChangeView: function () {
      this.saveUserSettings({ 'ui.common.view': this.view })
        .then(() => {
          this.onOpenInNewTab()
          this.updateDefaultView()
        })
    },
    onOpenInNewTab: function () {
      window.open(this.url, '_blank')
    }
  }
}
